import { inject } from 'vue'
import type { KyInstance } from 'ky'

export function useApi(): KyInstance {
  const api = inject<KyInstance>('api')
  if (!api) {
    throw new Error(
      'API client not provided. Ensure api plugin is installed before mounting the app.'
    )
  }
  return api
}
